(function ($) {
    $.fn.extend({
        urlUtil: {
            queryToObject: queryToObject,
            objectToQuery: objectToQuery,
            mergeQuery: mergeQuery,
            parse: parse
        }
    });

    function queryToObject(query) {
        return query.replace(/^[?#]/, '').split('&').reduce((acc, param) => {
            let [key, value] = param.split('=');
            acc[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
            return acc;
        }, {});
    }

    function objectToQuery(obj) {
        return Object.keys(obj).filter(key => obj[key] !== null && obj[key] !== '').map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
    }

    function mergeQuery(url, objToMerge) {
        var parsed = parse(url || '');
        var urlData = queryToObject(parsed.search);
        var newData = Object.assign(urlData, objToMerge);
        return `${parsed.protocol}//${parsed.hostname}${parsed.pathname}?${objectToQuery(newData)}${parsed.hash}`;
    }

    function parse(url) {
        var link = document.createElement('a');
        link.href = url;
        return {
            protocol: link.protocol || window.location.protocol,
            host: link.host || window.location.host,
            hostname: link.hostname || window.location.hostname,
            port: link.port || window.location.port,
            pathname: ensureLeadingSlash(link.pathname),
            search: link.search,
            searchObject: queryToObject(link.search),
            hash: link.hash
        };
    }

    function ensureLeadingSlash(path) {
        return (path.length && path[0] !== '/' ? '/' : '') + path;
    }
}(window.jQuery));